'use es6';

import { isEmpty } from 'underscore';
export const EMPTY_JSON_BLOCK = '{\n  \n}';
export const getJsonString = (val, prettyPrint = false) => {
  let json = EMPTY_JSON_BLOCK;

  if (!val || isEmpty(val)) {
    return json;
  }

  try {
    json = prettyPrint ? JSON.stringify(val, null, 2) : JSON.stringify(val);
  } catch (e) {// Swallow error
  }

  return json;
};